import React, { Component } from 'react';
import './style.css';

import {
  Button,
  Form,
  Message,
  Grid,
  Input,
  Header,
  Segment,
} from 'semantic-ui-react';

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      loading: false,
      error: '',
      signIn: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.login = this.login.bind(this);
  }
  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  login(e) {
    e.preventDefault();
    const CRM_API_ROOT = process.env.REACT_APP_CRM_API_ROOT;
    const url = `${CRM_API_ROOT}/tokens`;
    const { email, password } = this.state;
    this.setState({ loading: true });
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      mode: 'cors', // no-cors, cors, *same-origin
      body: JSON.stringify({
        email,
        password,
      }),
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(({ token }) => {
        const ref = getQueryVariable('ref');
        if (ref) {
          window.location.replace(`${window.location.protocol}//${ref}`);
        }
        this.setState({ signIn: true });
      })
      .catch(err => {
        if (err.response.status === 401) {
          this.setState({ error: 'Nieprawidłowy login lub hasło' });
        }
        this.setState({ loading: false });
      });
  }
  render() {
    const noModuleAccess = getQueryVariable('noModuleAccess');
    return (
      <Grid centered verticalAlign="middle">
        <Grid.Column computer="4" mobile="14" tablet="8">
          {!this.state.signIn &&
            !noModuleAccess && (
              <Segment loading={this.state.loading} vertical>
                <Header textAlign="center" as="h3">
                  Wprowadź dane logowania
                </Header>
                <Form size="large" onSubmit={this.login}>
                  <Segment stacked secondary>
                    <Form.Field>
                      <Input
                        icon="user"
                        iconPosition="left"
                        onChange={this.handleChange}
                        name="email"
                        type="text"
                        placeholder="email"
                      />
                    </Form.Field>
                    <Form.Field>
                      <Input
                        icon="lock"
                        iconPosition="left"
                        onChange={this.handleChange}
                        name="password"
                        type="password"
                        placeholder="hasło"
                      />
                    </Form.Field>
                    <Button fluid size="large" color="teal" type="submit">
                      Zaloguj
                    </Button>
                  </Segment>
                </Form>
                {this.state.error.length > 0 && (
                  <Message warning content={this.state.error} />
                )}
              </Segment>
            )}
          {this.state.signIn && (
            <Header textAlign="center" as="h3">
              Zostałeś zalogowany
            </Header>
          )}
          {noModuleAccess && (
            <Header textAlign="center" as="h3">
              Nie masz dostępu danej usługi.
            </Header>
          )}
        </Grid.Column>
      </Grid>
    );
  }
}

export default LoginForm;

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/LoginForm/index.js